// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./checkbox.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.checkbox_checkbox_XWBdd {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  transition: 0.2s;
  background-color: var(--ui-white);
  transition-property: background-color;
  background-size: 100%;
  border: 1px solid var(--ui-black-transparent);
  outline: none;
}

.checkbox_checkbox_XWBdd:hover,
.checkbox_checkbox_XWBdd:focus,
.checkbox_checkbox_XWBdd:active,
.checkbox_checkbox_XWBdd:checked {
  border-color: var(--looks-secondary);
}

.checkbox_checkbox_XWBdd:focus,
.checkbox_checkbox_XWBdd:active {
  box-shadow: 0 0 0 3px var(--looks-transparent);
}

.checkbox_checkbox_XWBdd:checked {
  background-color: var(--looks-secondary);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-fancy-checkbox/checkbox.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,qCAAqC;EACrC,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,yDAAuC;AACzC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.checkbox {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  transition: 0.2s;\n  background-color: var(--ui-white);\n  transition-property: background-color;\n  background-size: 100%;\n  border: 1px solid var(--ui-black-transparent);\n  outline: none;\n}\n\n.checkbox:hover,\n.checkbox:focus,\n.checkbox:active,\n.checkbox:checked {\n  border-color: var(--looks-secondary);\n}\n\n.checkbox:focus,\n.checkbox:active {\n  box-shadow: 0 0 0 3px var(--looks-transparent);\n}\n\n.checkbox:checked {\n  background-color: var(--looks-secondary);\n  background-image: url('./checkbox.svg');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": `checkbox_checkbox_XWBdd`
};
export default ___CSS_LOADER_EXPORT___;
